// extracted by mini-css-extract-plugin
export default {"root":"Header_root__Hn1cj","title":"Header_title__rzFD1","navbar-brand":"Header_navbar-brand__B+pXu","navbar-link":"Header_navbar-link__n3ZdZ","logo":"Header_logo__nZ7K6"};